import {
    BrandVariants,
    Theme,
    createLightTheme,
    createDarkTheme,
} from '@fluentui/react-components';

/**
 * Bayer-green brand ramp for Fluent UI 9.
 *
 * The 16 shades were generated against WCAG relative-luminance targets so the
 * filled-primary shade (80) keeps a ≥4.5:1 contrast with white text. Feeding
 * this to `createLightTheme` / `createDarkTheme` recolours every brand surface —
 * primary buttons, links, focus rings, selection — in one consistent accent
 * instead of Fluent's default blue.
 */
export const bayerBrand: BrandVariants = {
    10: '#0F1D0C',
    20: '#162F10',
    30: '#1A3F11',
    40: '#1D4E11',
    50: '#215D12',
    60: '#236B11',
    70: '#267812',
    80: '#2A8414',
    90: '#329719',
    100: '#3CAA20',
    110: '#49BD2C',
    120: '#69CC51',
    130: '#9DD78F',
    140: '#C4E2BC',
    150: '#E0EEDD',
    160: '#F1F6F0',
};

export const bayerLightTheme: Theme = { ...createLightTheme(bayerBrand) };

export const bayerDarkTheme: Theme = { ...createDarkTheme(bayerBrand) };

// On a dark surface the mid-ramp reads better for brand text/links than the
// default dark mapping (the pattern Fluent's own docs recommend).
bayerDarkTheme.colorBrandForeground1 = bayerBrand[110];
bayerDarkTheme.colorBrandForeground2 = bayerBrand[120];
